export default "__VITE_ASSET__DJ$WqrAm__"